var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMicMute(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/mic-mute",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,10 C6.553,10 7,10.448 7,11 C7,13.757 9.243,16 12,16 C12.362,16 12.714,15.957 13.055,15.883 L13.055,15.883 L14.648,17.476 C14.127,17.69 13.573,17.836 13,17.919 L13,17.919 L13,20 L15,20 C15.55,20 16,20.45 16,21 C16,21.55 15.55,22 15,22 L15,22 L9,22 C8.45,22 8,21.55 8,21 C8,20.45 8.45,20 9,20 L9,20 L11,20 L11,17.92 C7.613,17.432 5,14.52 5,11 C5,10.448 5.447,10 6,10 Z M3.293,3.293 C3.684,2.902 4.316,2.902 4.707,3.293 L4.707,3.293 L20.707,19.293 C21.098,19.684 21.098,20.316 20.707,20.707 C20.512,20.902 20.256,21 20,21 C19.744,21 19.488,20.902 19.293,20.707 L19.293,20.707 L3.293,4.707 C2.902,4.316 2.902,3.684 3.293,3.293 Z M8,10.828 L12.156,14.984 C12.104,14.986 12.054,15 12,15 C9.794,15 8,13.206 8,11 L8,11 L8,10.828 Z M18,10 C18.553,10 19,10.448 19,11 C19,12.464 18.547,13.823 17.775,14.947 L17.775,14.947 L16.312,13.484 C16.738,12.75 17,11.909 17,11 C17,10.448 17.447,10 18,10 Z M12.0001,2 C14.2061,2 16.0001,3.794 16.0001,6 L16.0001,6 L16.0001,11 C16.0001,11.631 15.8401,12.22 15.5791,12.751 L15.5791,12.751 L8.0761,5.248 C8.4301,3.401 10.0521,2 12.0001,2 Z",
    id: "path-1",
    fill: "#000000",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicMute);
export default __webpack_public_path__ + "static/media/mic-mute.8118747e.svg";
export { ForwardRef as ReactComponent };